import React from 'react'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'

import { CMSState, Link } from '../types.gen'
import { link, getClassName, linkWrapper } from '../utils.gen'
import { toRelativeUrl } from '../../../../helpers'
import { ButtonData } from '../../../wordpress/types_and_parser/extra_types.mod'

export type TextBlockProps<CustomBlockData, extra_images> = {
  title?: string
  text: string
  primary_button?: ButtonData
  secondary_button?: ButtonData
  has_show_more: boolean
}

export type TextBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function TextBlock<CustomBlockData, extra_images>(
  props: TextBlockProps<CustomBlockData, extra_images>,
  options?: { style?: TextBlockStyle; key?: string }
): IOWidget<CMSState<CustomBlockData, extra_images, never>, Action<CMSState<CustomBlockData, extra_images, never>>> {
  return (s: CMSState<CustomBlockData, extra_images, never>) =>
    mk_widget({
      run: onDone => (
        <section
          className={getClassName(options, 'block_classname', 'container')}
          key={options && options.key ? options.key : 'text-block'}
        >
          <div className={getClassName(options, 'inner_classname', 'py-5')}>
            <header className={getClassName(options, 'header_classname', '')}>
              <h2 className={getClassName(options, 'title_classname', 'mb-3')}>{props.title}</h2>
            </header>

            <div className={getClassName(options, 'content_classname', '')}>
              <div
                className={getClassName(options, 'text_classname', '')}
                dangerouslySetInnerHTML={{ __html: props.text }}
              />
            </div>

            {(props.primary_button || props.secondary_button) && (
                    <ul className="hero__buttons">
                      {props.primary_button && (
                        <li className="hero__button">
                          {link(linkWrapper({title: props.primary_button.text, url: props.primary_button.url}),
                            { classname: 'btn btn--primary' },
                            props.primary_button.text
                          )}
                        </li>
                      )}
                      {props.secondary_button && (
                        <li className="hero__button">
                          {link(linkWrapper({title: props.secondary_button.text, url: props.secondary_button.url}),
                            { classname: 'btn btn--secondary' },
                            props.secondary_button.text
                          )}
                        </li>
                      )}
                    </ul>
                  )}
          </div>
        </section>
      )
    })
}
